export const datetimeFormats = {
  en: {
    mm_ss: {
      minute: '2-digit',
      second: '2-digit'
    },
    HH_mm: {
      hour: '2-digit',
      minute: '2-digit'
    },
    ddd: {
      weekday: 'short'
    },
    dddd: {
      weekday: 'long'
    },
    DD: {
      day: '2-digit'
    },
    MMM_YY: {
      month: 'short',
      year: '2-digit'
    },
    DD_MM_YYYY: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    },
    D_MMMM_YYYY: {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    DD_MMMM_YYYY: {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    ddd_DD_MMMM_YYYY: {
      weekday: 'short',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    dddd_D_MMMM_YYYY: {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    dddd_DD_MMMM_YYYY: {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    ddd_DD_MMM_YYYY_HH_mm: {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }
  },
  de: {
    mm_ss: {
      minute: '2-digit',
      second: '2-digit'
    },
    HH_mm: {
      hour: '2-digit',
      minute: '2-digit'
    },
    ddd: {
      weekday: 'short'
    },
    dddd: {
      weekday: 'long'
    },
    DD: {
      day: '2-digit'
    },
    MMM_YY: {
      month: 'short',
      year: '2-digit'
    },
    DD_MM_YYYY: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    },
    D_MMMM_YYYY: {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    DD_MMMM_YYYY: {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    ddd_DD_MMMM_YYYY: {
      weekday: 'short',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    dddd_D_MMMM_YYYY: {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    dddd_DD_MMMM_YYYY: {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    ddd_DD_MMM_YYYY_HH_mm: {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }
  },
  'sr': {
    mm_ss: {
      minute: '2-digit',
      second: '2-digit'
    },
    HH_mm: {
      hour: '2-digit',
      minute: '2-digit'
    },
    ddd: {
      weekday: 'short'
    },
    dddd: {
      weekday: 'long'
    },
    DD: {
      day: '2-digit'
    },
    MMM_YY: {
      month: 'short',
      year: '2-digit'
    },
    DD_MM_YYYY: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    },
    D_MMMM_YYYY: {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    DD_MMMM_YYYY: {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    ddd_DD_MMMM_YYYY: {
      weekday: 'short',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    dddd_D_MMMM_YYYY: {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    dddd_DD_MMMM_YYYY: {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    ddd_DD_MMM_YYYY_HH_mm: {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }
  }
};
